import { getSectorials } from 'api/services/wp';
import { useEffect, useState } from 'react';
import { uniqueId } from 'lodash';
import InfiniteGallery from 'modules/website/shared/components/InfiniteGallery';
import JuntsButton from 'modules/website/shared/components/JuntsButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import './PolitiquesSectorialsMobile.scss';

function PolitiquesSectorialsMobile() {
  const [sectorialsIcons, setSectorialsIcons] = useState([]);

  useEffect(() => {
    getSectorials().then(({ data }) => {
      const sectorials = data[0].acf.sectorial;
      const icons = sectorials.map((sectorial) => sectorial.icona);

      setSectorialsIcons(icons);
    });
  }, []);

  function renderIcons() {
    return sectorialsIcons.map((icon) => (
      <img
        src={icon}
        alt="Icon"
        className="invert w-[50px] h-[50px]"
        key={uniqueId('sectorial-icons-gallery-')}
      />
    ));
  }

  return (
    <div className="politiques-sectorials-mobile">
      <div className="d-flex flex-column flex-gap-md">
        <InfiniteGallery>{renderIcons()}</InfiniteGallery>
        <InfiniteGallery direction="right">{renderIcons()}</InfiniteGallery>
      </div>

      <div className="flex-center" style={{ padding: '2rem' }}>
        <Link to="/politiques-sectorials">
          <JuntsButton customBg="#27535c">
            Visita la pàgina <ArrowForwardIcon />
          </JuntsButton>
        </Link>
      </div>
    </div>
  );
}

export default PolitiquesSectorialsMobile;
